import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";

const FAQS = [
  { q: "Do you clean only one bedroom in a shared apartment?", a: "Yes. Many college apartments lease each bedroom separately. We only clean what you've paid for — your student's bedroom and any common areas you've opted in to." },
  { q: "Who pays — me or my student?", a: "You. Your student doesn't see billing unless you explicitly invite them to. They can request additional services through their portal, but it's always your call." },
  { q: "How does the report work?", a: "After every visit our cleaner submits a report including before/after photos, cleanliness & organization scores, notes on damages or maintenance issues, and recommendations. You get it by email automatically." },
  { q: "Can I split common-area cleaning with roommates?", a: "Yes — when you add common areas you can optionally request invoice splitting between roommate parents." },
  { q: "Can I cancel anytime?", a: "Yes. Recurring plans can be cancelled or paused from the parent portal any time before the next scheduled visit." },
  { q: "Which payment methods are supported?", a: "Credit/debit cards, Apple Pay and Google Pay via secure Stripe checkout. Recurring plans are billed automatically." },
  { q: "What if my student lives off-campus?", a: "That's fine — we operate in most college towns and serve dorms, apartments, and individually-leased units." },
  { q: "What about damages?", a: "If our cleaner spots damage they flag it in the report. We never charge for damages we didn't cause." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <Badge variant="outline" className="mb-3">FAQ</Badge>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-primary">Questions, answered.</h1>
      <p className="mt-3 text-muted-foreground">Can't find what you need? Tap the chat bubble — Clara's standing by.</p>

      <Accordion type="single" collapsible className="mt-10">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="font-display text-left">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
